export default {
  productGrade: {
    id: 'product_grade',
    defaultMessage: 'Esthetic condition:',
  },
  productGradeWithNewBattery: {
    id: 'product_grade_with_new_battery',
    defaultMessage: '{grade} with new battery',
  },
  battery_new: {
    id: 'product_page_no_grade_labels_battery_new',
    defaultMessage: 'New battery',
  },
  battery_90_99: {
    id: 'product_page_no_grade_labels_battery_90_99',
    defaultMessage: 'Battery 90-99%',
  },
  battery_standard: {
    id: 'product_page_no_grade_labels_battery_standard',
    defaultMessage: 'Standard battery',
  },
  battery_new_variant_b: {
    id: 'ProductPage.Pickers.Battery.NewBattery.VariantB.Label',
    defaultMessage: 'New battery',
  },
  battery_new_variant_c: {
    id: 'ProductPage.Pickers.Battery.NewBattery.VariantC.Label',
    defaultMessage: '100% battery health',
  },
  battery_90_99_variant_b: {
    id: 'ProductPage.Pickers.Battery.9099.VariantB.Label',
    defaultMessage: 'Great battery',
  },
  battery_90_99_variant_c: {
    id: 'ProductPage.Pickers.Battery.9099.VariantC.Label',
    defaultMessage: '90-99% battery health',
  },
  battery_standard_variant_b: {
    id: 'ProductPage.Pickers.Battery.Standard.VariantB.Label',
    defaultMessage: 'Good battery',
  },
  battery_standard_variant_c: {
    id: 'ProductPage.Pickers.Battery.Standard.VariantC.Label',
    defaultMessage: '80-99% battery health',
  },
  outlet_offer_type: {
    id: 'outlet_cart_offer_type',
    defaultMessage: 'Heavy signs of use',
  },
}
